export default function IsAdmin() {
    let results = 0;

    if (localStorage.getItem("user_subid") != undefined &&
        'Uecf744ba82394b46a42e0e08c9b89b05,U13b9d7530f100d178924ae982f0fa125'.indexOf(localStorage.getItem("user_subid")) > -1) {
        results = 1;
    }

    return results;
}